import React, { Suspense, useEffect, useState } from 'react';
import { FormTitle } from 'page/Application/ManageCompanyList/component/Form';
import {
  Container,
  FooterButtonContainer,
  FormWrapper,
} from 'components/Form/Template/styled';
import useModalConfirm from 'hook/useModalConfirm';
import { Alert, Form, Spin } from 'antd';
import { FormFooterSubmit, FormLabelGrid } from 'components/Form';
import FormValidateTextArea from 'components/Form2/FormValidateTextArea';
import useMultiLanguage from 'hook/useMultiLanguage';
import { useNavigate } from 'react-router-dom';
import { MANAGE_TRACKING_CODE_PATH } from 'constant/appPath';
import { FormNote } from 'page/Application/ManageNotificationList/component/Form';
import FormValidateTextAndNumber from 'components/Form2/FormValidateTextAndNumber';
import {
  Grid1,
  Grid2,
  GridLayout,
} from 'page/Application/ManageTrackingCode/component/FormTrackingCode/styled';

const FormTrackingCode = ({
  isLoading,
  titleForm,
  type,
  isLoadingSubmit,
  onFinish,
  isError,
  errorMessage,
  isDisable,
  isDisableDelete,
  isEdit,
  handleDeleteTrackingCode,
  setIsDisableDelete,
  setIsDisable,
  isOnline,
  errorNetWork,
  formDetailData,
}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { handleConfirmAction, contextHolder } = useModalConfirm();
  const { APPLICATION_OK_TEXT, APPLICATION_CANCEL_TEXT } = useMultiLanguage();
  const [isDisableSubmit, setIsDisableSubmit] = useState(!isEdit ?? true);

  const handleCancel = () => {
    if (isOnline) {
      navigate(`/${MANAGE_TRACKING_CODE_PATH}`);
    } else {
      errorNetWork();
    }
  };

  const handleValuesChange = () => {
    const { title, header, body } = form.getFieldsValue();
    setIsDisableSubmit(
      (!header?.trim() || !title?.trim()) && (!title?.trim() || !body?.trim()),
    );
  };

  useEffect(() => {
    if (isEdit && formDetailData?.data) {
      const detailData = formDetailData?.data;
      form.setFieldsValue({
        title: detailData?.title || '',
        header: detailData?.header || '',
        body: detailData?.body || '',
      });
    }
  }, [form, formDetailData?.data, isEdit]);

  return (
    <Suspense fallback={isLoading}>
      {contextHolder}
      <FormTitle
        notice={'注意：'}
        title={titleForm}
        type={type}
        styles={{ color: '#9D1C49' }}
      />
      <FormWrapper>
        <Container>
          <Spin spinning={isLoading || isLoadingSubmit}>
            <Form
              name="register-account-partner"
              form={form}
              layout="horizontal"
              size="large"
              onFinish={onFinish}
              onValuesChange={handleValuesChange}
            >
              <GridLayout>
                <Grid2>
                  {(isError || errorMessage) && (
                    <Alert
                      message={errorMessage}
                      type="error"
                      style={{ marginBottom: '24px' }}
                    />
                  )}
                </Grid2>

                {/* start title */}
                <Grid1>
                  <FormLabelGrid labelText={'タイトル'} required={true} />
                </Grid1>
                <Grid2>
                  <FormValidateTextAndNumber name="title" required={true} />
                </Grid2>
                {/* end title */}

                {/* start header */}
                <Grid1>
                  <FormLabelGrid labelText={'<head>内'} required={false} />
                </Grid1>
                <Grid2>
                  <FormValidateTextArea name="header" minHeight={'160px'} />
                </Grid2>
                {/* end header */}

                {/* start body */}
                <Grid1>
                  <FormLabelGrid labelText={'<body>内'} required={false} />
                </Grid1>
                <Grid2>
                  <FormValidateTextArea
                    name="body"
                    marginBottom={0}
                    minHeight={'160px'}
                  />
                  <FormNote
                    text={
                      '<head>内、<body>内両方、またはどちらかの入力が必要です。'
                    }
                  />
                </Grid2>
                {/* end body */}

                <Grid2>
                  <FooterButtonContainer>
                    <FormFooterSubmit
                      isDisable={isDisable}
                      isDisableDelete={isDisableDelete}
                      isDisableSubmit={isDisableSubmit}
                      textOk={isEdit ? '保存' : '登録'}
                      textCancel={'キャンセル'}
                      textDelete={'削除'}
                      isDelete={isEdit}
                      onDelete={() => {
                        handleConfirmAction({
                          confirmFn: handleDeleteTrackingCode,
                          title: `${formDetailData?.data?.title}を削除してもよろしいでしょうか？`,
                          cancelText: <span> キャンセル</span>,
                          okText: <span> 削除</span>,
                          setIsDisable: setIsDisableDelete,
                        });
                        setIsDisableDelete(true);
                      }}
                      onCancel={() => {
                        handleConfirmAction({
                          confirmFn: handleCancel,
                          title: (
                            <span>
                              {' '}
                              {isEdit
                                ? 'トラッキングコード情報の変更をキャンセルしてもよろしいでしょうか？'
                                : 'トラッキングコード登録をキャンセルしてもよろしいでしょうか？'}
                            </span>
                          ),
                          cancelText: <span> {APPLICATION_CANCEL_TEXT}</span>,
                          okText: <span> {APPLICATION_OK_TEXT}</span>,
                          setIsDisable: setIsDisable,
                        });
                        setIsDisable(true);
                      }}
                    />
                  </FooterButtonContainer>
                </Grid2>
              </GridLayout>
            </Form>
          </Spin>
        </Container>
      </FormWrapper>
    </Suspense>
  );
};

export default FormTrackingCode;
